import React, { useState } from 'react';
import OpportunityInfo from './OpportunityInfo';
import { getOpportunityData } from '@components/OpportunityListing/utils/helper';
import { isTBillsView } from '@components/OpportunityListing/utils/utils';
import OpportunityInfoStrip from './OpportunityInfoStrip';
import ShowInterestModal from '../ShowInterestInOpportunityCard';
import { isUpcomingOpportunity, staticOpportunity } from '@helpers/constants';
import { useRouter } from 'next/router';
import useWindowDimensions from '@hooks/useWindowDimensions';
import routes from '@helpers/routes';
import { triggerCustomGaEvent } from '@helpers/miscelleanous';
import { activeOpportunityListingGaEventsName } from '@helpers/ga-events-name-enum';
import { getReferralCode } from '@services/identity.service';
import {
    logEvent,
    moengageEventConstants,
    moengageEventArgsConstants,
} from '@services/moengage';

const OpportunityListingCard = ({
    opportunity,
    type,
    cardType,
    interestRecorded,
    isUpcoming,
    isFestiveDeal,
    isAdminDeal,
    isClosed,
    isAuthorized,
}) => {
    const isBonds = !isTBillsView(type);
    const router = useRouter();
    const { width } = useWindowDimensions();
    const opportunityData = getOpportunityData(opportunity, isBonds, isClosed);

    const [showInterestInOpportunityModal, setShowInterestInOpportunityModal] =
        useState(false);
    const [shownInterest, setShownInterest] = useState(interestRecorded);
    const handleShowInterestModal = () => {
        setShowInterestInOpportunityModal((prevState) => !prevState);
    };

    const goToOpportunity = (opportunity) => {
        if (!isAuthorized) {
            triggerCustomGaEvent(
                activeOpportunityListingGaEventsName.CLICKED_ACTIVE_OPPORTUNITY_CARD,
                {
                    opportunityId: opportunity?.id,
                    isin: opportunity?.isin,
                    referralCode: getReferralCode(),
                }
            );
            logEvent({
                eventName:
                    moengageEventConstants.CLICKED_ACTIVE_OPPORTUNITY_CARD,
                parameters: {
                    [moengageEventArgsConstants.OPPORTUNITY_ID]:
                        opportunity?.id,
                    [moengageEventArgsConstants.ISIN]: opportunity?.isin,
                    [moengageEventArgsConstants.REFERRAL_CODE]:
                        getReferralCode(),
                },
            });
        }
        if (
            staticOpportunity(opportunity?.id) ||
            isUpcomingOpportunity(opportunity)
        ) {
            width < 768 &&
                !shownInterest &&
                setShowInterestInOpportunityModal(true);
            return;
        }
        if (isAuthorized) router.push(`/opportunity/${opportunity?.id}`);
        else router.push(routes.bonds.byIsin(opportunity?.isin));
    };

    return (
        <div className="w-full max-w-[408px] flex flex-col mx-auto h-full">
            <div
                className="flex flex-col flex-1 cursor-pointer"
                onClick={() => goToOpportunity(opportunity)}
            >
                <OpportunityInfo
                    isBonds={isBonds}
                    opportunityData={opportunityData}
                    cardType={cardType}
                    onClickInterested={handleShowInterestModal}
                    isUpcoming={isUpcoming}
                    isFestiveDeal={isFestiveDeal}
                    isAdminDeal={isAdminDeal}
                    isClosed={isClosed}
                    state={opportunity?.state}
                    shownInterest={shownInterest}
                    riskRating={opportunityData.riskRating}
                />
                <OpportunityInfoStrip
                    cardType={cardType}
                    interestRecorded={interestRecorded}
                    isUpcoming={isUpcoming}
                    isFestiveDeal={isFestiveDeal}
                    isAdminDeal={isAdminDeal}
                    isClosed={isClosed}
                    interestPayoutFrequency={
                        opportunityData.interestPayoutFrequency
                    }
                />
            </div>
            {showInterestInOpportunityModal ? (
                <ShowInterestModal
                    show={showInterestInOpportunityModal}
                    onClose={handleShowInterestModal}
                    dealName={opportunityData?.title}
                    slug={opportunityData?.slug}
                    opportunityId={opportunityData.id}
                    setShownInterest={setShownInterest}
                />
            ) : null}
        </div>
    );
};

export default OpportunityListingCard;
